import api from '@/services/cas'
import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    items: [],
    list: [],
    tax: [],
    totalCT: 0,
    roundOff: 0 ,
    editlist:
    {
    select: {
    p_id: 0,
    name: 'Parda',
    unit: 'pcs',
    hsn: 6304,
    cgst: 2.5,
    sgst: 2.5,
    gst: 5,
    rate: 500,
    rule12: true
    },
      sl: 1,
      qty: null,
      discount: 0,
      rate: 0,
      total: 0,
      total_wd: 0,
      index:0
    },

    
    defaultItem:
      {
        select: {
        p_id: 0,
        name: 'Parda',
        unit: 'pcs',
        hsn: 6304,
        cgst: 2.5,
        sgst: 2.5,
        gst: 5,
        rate: 500,
        rule12: true
        },
        sl: 1,
        qty: null,
        discount: 0,
        rate: 0,
        total: 0,
        total_wd: 0,
        index: 0
      },
    date: (new Date).toString(),
    tax_inc: true,
    st_select: { state: 'assam', code: 18},
    st_code: null, //[{ state: 'assam', code: 18}, { state: 'meghalaya', code: 16}, { state: 'tamil', code: 17}],
    c_name: null,
    address: null,
    partyList: null, //['neela','cash','card','vinked'],

    editedIndex: -1,
    dialog: false

  },
  getters: {
    formatDate(state) {
      const date = new Date(state.date)
      const day = (date.getDate() < 10) ?  '0' + date.getDate()  : date.getDate()
      const month = (date.getMonth()+1 <10) ? '0' + (date.getMonth()+1) : date.getMonth()+1
      const year = date.getFullYear()
      const fdate = day + '/' + month + '/' + year
      return fdate
    },
    total: (state) =>  {
      //console.log(`qty : ${state.editlist.qty},  rate: ${state.editlist.rate}`)
      let total = state.editlist.qty * state.editlist.rate 
      state.editlist.total = total
      return total
    },
    totalwd: (state) => {
      let wd= (state.editlist.qty * state.editlist.rate) - state.editlist.discount
      state.editlist.total_wd = wd
      return wd 
    },
    taxCal: (state, getters,rootstate) =>  {
      var len = state.list.length
      var tax=[]
      state.tax = []
      for( var i=0; i < len; i++)
      {
        state.list[i].gst =   state.list[i].select.gst
        state.list[i].cgst =   state.list[i].select.cgst
        state.list[i].sgst =   state.list[i].select.sgst
        if(state.list[i].select.rule12 == true) 
        {
          if (state.tax_inc == false && (state.list[i].total_wd/state.list[i].qty) > 1000 ){
            state.list[i].gst =  12
            state.list[i].sgst =  6 
            state.list[i].cgst = 6 
          }
          else if ( state.tax_inc == true && (state.list[i].total_wd/state.list[i].qty) > 1050 ) {
            state.list[i].gst =  12
            state.list[i].sgst =  6 
            state.list[i].cgst = 6 
            }
          }

      }  

      state.list.push('empty-array');
      state.list.splice(-1,1);

      for (var i=0; i< state.list.length; i++){
        var obj ={
        taxable_value: state.list[i].total_wd,
        gst: Number(state.list[i].gst),
        cgst: Number(state.list[i].cgst),
        cgst_amt: null,
        sgst: Number(state.list[i].sgst),
        sgst_amt: null,
        igst_amt: null,
        hsn: Number(state.list[i].select.hsn),
        unit: state.list[i].select.unit,
        qty: Number(state.list[i].qty),
        total: null ,
        sl: null
        }
        if(tax.length == 0)
        {
          getters.taxCalInc(obj)
          obj.sl=1
          tax.push(obj)
          //break
        }
        else {
          var eq = false
          for(var j=0; j< tax.length; j++)  {
            if(tax[j].gst == obj.gst && tax[j].hsn == obj.hsn && tax[j].unit == obj.unit) {
              obj.taxable_value = getters.round(Math.round(tax[j].total) + obj.taxable_value)
              getters.taxCalInc(obj)
              obj.qty = getters.round(tax[j].qty + obj.qty)
              obj.sl= tax.length+1
              Vue.set(tax,j,obj)
              eq = true
              break
            }
          }
          if (!eq) {
            getters.taxCalInc(obj)
            obj.sl =tax.lenght +1
            tax.push(obj)
          }
      }

        obj={}
      }

      state.totalCT=0
      for(var j=0; j< tax.length; j++){
        state.totalCT += tax[j].total
      }
      var r=  Math.round(state.totalCT)
      state.roundOff =  getters.round(r - state.totalCT)
      state.totalCT =r

      if(tax.length>1){
        tax.sort(function(a,b){
          return a.gst - b.gst
        })
      }
      
      state.tax =tax
       state.tax.push({hhh: 'hhhh'});
       state.tax.splice(-1,1);
      tax =[]
      return state.tax
    },
    round: (state) => (num) => {
      return Number(Math.round(num + 'e2')+ 'e-2')
    },
    taxCalInc: (state,getters,rootstate) => (obj) => {
      if(state.tax_inc== true)
      {
        obj.taxable_value = getters.round((obj.taxable_value * 100) / (100 + obj.gst))
      }
      if(state.st_select.code == rootstate.company.company.code) 
      {
        obj.igst=null
        obj.cgst_amt = getters.round(((obj.taxable_value) * obj.cgst)/100)  
        obj.sgst_amt = getters.round(((obj.taxable_value) * obj.sgst)/100) 
        obj.total = getters.round(obj.taxable_value + obj.cgst_amt + obj.sgst_amt)  
        //  console.log('obj cgst  ' + obj.cgst_amt + " sgst   " + obj.sgst_amt + "  taxable   " + obj.taxable_value)
      }
      else {
        obj.cgst_amt = null
        obj.sgst_amt = null
        obj.igst_amt = getters.round((obj.taxable_value * obj.gst)/100)  
        obj.total= getters.round(obj.taxable_value + obj.igst_amt)  
      }
      return obj
    },

  },
  mutations: {
    listItem(state) {
      var data= Object.assign({}, state.editlist)
      //console.log(`data ${data.select.name}`)
      //state.editlist.total_wd = 
      var val = data.total_wd / data.qty
   // console.log(state.items[data.select.p_id].p_id)
     // data.select=JSON.parse(JSON.stringify(state.items[data.select.p_id]))
//console.log('data display' + data.select.name)
      if(state.editedIndex==-1) {
        //console.log(state.editedIndex)
        data.sl = state.list.length+1
        data.index = state.list.length
        state.list.push(data)
      } else {
        //state.list[state.editedIndex]= data
        state.list.splice(state.editedIndex, 1, data)
      }
        // state.editlist = Object.assign({}, state.defaultItem)
        // state.editlist.select = state.items[0]
          
          state.editlist.select = Object.assign({}, state.items[0])
          state.editlist.rate = state.items[0].rate
        //state.editlist.rate= state.editlist.select.rate
        //console.log(`rate edit list ${state.editlist.select.rate}`)
        state.editedIndex=-1
        data=null
    },
    setDate (state,data) {
      state.date=data
    },
    tax_inc(state,value) {
      state.tax_inc = value
    },
    partyName(state,value) {
      state.c_name=value
      //console.log(value)
      //state.partyList=value
    },
    address(state,value) {
      state.address = value
    },
    stSelect(state,value) {
      state.st_select= value
      //console.log(state.st_select)
    },
    editItem(state,value) {
      state.editedIndex = state.list.indexOf(value) //state.list[value]
      state.editlist = Object.assign({} ,value)
      state.editlist.select.rate =  value.rate
      state.dialog= true
    },
    dialog(state,value) {
      state.dialog = value
      state.editedIndex= -1
      //state.editlist =Object.assign({},state.defaultItem)
      state.editlist.select = state.items[0]
      state.editlist.rate = state.items[0].rate
    },
    deleteItem(state,index) {
      confirm('Are you sure you want to delete this item?') && state.list.splice(index,1)
      for(var i=0;i< state.list.length; i++) {
        state.list[i].sl =i+1
      }
    },
    partyList(state,data) {
      state.partyList =data
    },
    productname( state, data){
      state.editlist.select = data
      state.editlist.rate = state.editlist.select.rate
      //console.log(state.editlist.select)
    },
    qty(state, qty) {
      state.editlist.qty= qty
    },
    rate( state, rate) {
      state.editlist.rate=rate
    },
    discount ( state, discount) {
      state.editlist.discount = discount
    },
    items ( state, items) {
      state.items =items
    },
    stcode: (state, stcode) => {
      state.st_code=stcode
    },
  },
  actions: {
    productname( {commit}, data) {
      commit('productname', data)
    },
    qty ( {commit}, qty) {
      commit('qty', qty)
    },
    rate( {commit}, rate) {
      commit('rate', rate)
    },
    discount ( {commit}, discount) {
      commit('discount', discount)
    },

   fetchitem: async ( {commit}, state) => {
      let items = (await api.fetchItem()).data
      //console.log(items)
      commit('items', items)
    },
    sav({commit,state,rootState}){
     // var a = ((state.list))
      //a= JSON.parse(a)
      //console.log(rootState)

     const data ={
        date: state.date,     
        listItems: state.list,
        tax: state.tax,
        tax_inc: state.tax_inc,
        st_code: state.st_select,
        cname: state.c_name,
        address: state.address,
        cmp: rootState.company,
        bookseries: 'POS'
      }
      //var a= JSON.parse(data.listItems)
      //console.log(a)
      api.submit(data)
    },
    listItem(context) {

      context.commit('listItem')
    },
    setDate(context,data) {
      //console.log(data)
      context.commit('setDate', data)
    },
    tax_inc(context,value) {
      context.commit('tax_inc',value)
    },
    partyName(context,value) {
      context.commit('partyName',value)
    },
    address(context,value) {
      context.commit('address', value)
    },
    stcode: async ({commit} ) => {
      let stcode = (await api.fetchStates()).data
      commit('stcode',stcode)
    },
    stSelect: ( {commit }, stselect) => {
      commit('stSelect', stselect)
    },
    editItem(context, value) {
      context.commit('editItem', value)
    },
    closeSaleForm(context,value) {
      context.commit('dialog',value)
    },
    deleteItem(context,index) {
      context.commit('deleteItem',index)
    },

    async fetchParty(context, data) {
      const party = (await api.fetchParty(data)).data
      await context.commit('partyList', party)
      const cname =party.find( o => o.p_id == true)
      if(!cname){
        //console.log('if ' + cname)
        await context.commit('partyName',party[0].name)
      }
      else {
        await context.commit('partyName',cname.name)
      }
      //console.log(party.find( o => o.p_id == true))
      //await context.commit('partyName',party[0])
    }

  }
}
